



















import { mapGetters } from "vuex";
import { apiClient } from "@/services/api-client";

export default {
  name: "BestellijstNewLijst",
  data() {
    return {
      naam: null
    };
  },
  computed: {
    ...mapGetters(["getUsername", "selectedLocationId"])
  },
  methods: {
    submit() {
      if (this.selectedLocationId != null) {
        apiClient
          .addNewBestellijst({
            naam: this.naam,
            materieelLocatieNr: this.selectedLocationId
          })
          .then(response => {
            this.$emit("success", response.bestellijstId);
            this.$store.dispatch("bestellijstenRequested");
            this.$store.dispatch("snackbarAdded", {
              text: this.$t("FavorietNewLijst.success"),
              type: "success"
            });
          });
      } else {
        this.$store.dispatch("snackbarAdded", {
          text: this.$t("Details.geen_locatie"),
          type: "warning"
        });
      }
    }
  }
};
